import {usePermissionsContext} from "./permissions-context";

export const usePermission = () => {
    const {hasPermission, isSuperuser, perfil, user} = usePermissionsContext();

    return {hasPermission, isSuperuser, perfil, user};
};